
export default [
    {//首页
        path: '/',
        redirect: '/square',
        component: function (resolve) {
            require(['./Layout.vue'], resolve);
        },
        children: [
            {
                path: '/square',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/videosquare',
                component: function (resolve) {
                    require(['./video_square.vue'], resolve);
                }
            },
            {
                path: '/video',
                component: function (resolve) {
                    require(['./Video.vue'], resolve);
                }
            },
            {
                path: '/Sora',
                component: function (resolve) {
                    require(['./Sora.vue'], resolve);
                }
            },
            {
                path: '/pika',
                component: function (resolve) {
                    require(['./Pika.vue'], resolve);
                }
            },
            {
                path: '/luma',
                component: function (resolve) {
                    require(['./luma.vue'], resolve);
                }
            },
            {
                path: '/Viggle',
                component: function (resolve) {
                    require(['./Viggle.vue'], resolve);
                }
            },
            {
                path: '/Anime',
                component: function (resolve) {
                    require(['./anime.vue'], resolve);
                }
            },
            {
                path: '/Face',
                component: function (resolve) {
                    require(['./face.vue'], resolve);
                }
            },
            {
                path: '/kelingTool',
                component: function (resolve) {
                    require(['./kelingTool.vue'], resolve);
                }
            },
            {
                path: '/favorites',
                component: function (resolve) {
                    require(['./favorites.vue'], resolve);
                }
            },
            {
                path: '/inventory',
                component: function (resolve) {
                    require(['./inventory.vue'], resolve);
                }
            },
            // {
            //     path: '/invite',
            //     component: function (resolve) {
            //         require(['./invite.vue'], resolve);
            //     }
            // },
            {
                path: '/member',
                redirect: '/square',
            },
            {
                path: '/tuiguang',
                name: 'index_ad',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
            {
                path: '/zz360tg',
                name: 'zz360tg',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
             {
                path: '/tg:tg',
                name: 'tg',
                component: function (resolve) {
                    require(['./square.vue'], resolve);
                }
            },
        ]
    },
    {//联系我们
        path: '/contact',
        component: function (resolve) {
            require(['./contact.vue'], resolve);
        },

    },
    {//联系我们
        path: '/drawDetail',
        component: function (resolve) {
            require(['./drawDetail.vue'], resolve);
        },
    },
    {// 退款
        path:"/reqrefund",
        name:"reqrefund",
        component:() => import('VIEWS/Reqrefund.vue')
    },
]